<template>
  <div>
    <div class="mask" v-if="ewmPopShow">
      <img src="@/assets/ewm.png" class="ewm" alt="" srcset="" />
      <img
        src="@/assets/close.png"
        @click="ewmPopShow = false"
        class="close"
        alt=""
        srcset=""
      />
    </div>
    <div class="back">
      <div @click.stop="back">
        首页 
        <!-- <img src="@/assets/tabbaricon/home_onpress.png" /> -->
      </div>
      <div @click.stop="ewmPopShow = true">
        公众号
        <!-- <img src="@/assets/teacher/wechat.png" /> -->
      </div>
    </div>
  </div>
</template>
<script>
import { HERF } from "@/utils/tool";
export default {
  data() {
    return {
      ewmPopShow: false,
    };
  },
  methods: {
    back() {
      window.location.href = HERF + "/h5/#/";
    },
  },
};
</script>

<style scoped lang="scss">
.back {
  position: fixed;
  top: 75%;
  right: 10px;
  width: 40px;
  // background: #4cd8d4;
  color: #fff;
  // width: 100%;
  // height: 50px;
  text-align: center;
  line-height: 50px;
  z-index: 667;
  // display: flex;
  div {
    background: #4cd8d4;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    font-size: 0.25rem;
    text-align: center;
    line-height: 50px;
    img {
      width: 40px;
      height: 40px;
      display: block;
      // box-shadow: 0px 1px 15px 0px rgba(0, 0, 0, 0.2);
    }
    &:first-child{
      margin-bottom: 10px;
      // border-right: 1px solid #fff;
      // box-sizing: border-box;
    }
  }
}
.mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .ewm {
    width: 80%;
  }
  .close {
    margin-top: 0.4rem;
    height: 0.8rem;
    width: 0.8rem;
  }
}
</style>
